import { useState, useEffect } from "react";
import { uniqBy } from "lodash";
import { useAppDispatch, useAppSelector } from "./reduxHooks";
import { selectDrawerSelectedAccountId } from "app/data/selectors";
import { resetQueriedObjects } from "app/features";

const useSelectSearch = (array: any[], objects: any[]) => {
  const dispatch = useAppDispatch();
  const drawerSelectedAccountId = useAppSelector(selectDrawerSelectedAccountId);

  const [selectedLocalObjects, setSelectedLocalObjects] = useState<any[]>([]);

  useEffect(() => {
    const updateSelectedLocalObjects = () => {
      setSelectedLocalObjects((prev: any) => {
        // Ensure array is actually an array before calling .some()
        const arrayToCheck = Array.isArray(array) ? array : [];
        const selectedItems = prev.filter((item: any) =>
          arrayToCheck.some((value: any) => value === item?.uniqueId)
        );
        const combinedArray = [...selectedItems, ...(objects || [])];
        return uniqBy(combinedArray, "uniqueId");
      });
    };

    // Call the function with the provided array
    updateSelectedLocalObjects();
  }, [array, objects]);

  useEffect(() => {
    dispatch(resetQueriedObjects());
  }, [drawerSelectedAccountId]);

  return selectedLocalObjects;
};

export default useSelectSearch;
